// extracted by mini-css-extract-plugin
export default {"top_container":"register_page_top_container__UZzKA","container":"register_page_container__rQYSW","form_container":"register_page_form_container__Sjm1v"};